<!-- 
	AdminUserList
	props: User
  role: Admin
	Called by @/views/Admin to display list of all users at a limit of 25 at a time
-->

<template>
	<div class="admin-user-list">
		<!--div class="text-right text-sm">
			Viewing Users: {{ skip }} to {{ skip + 25 }}
		</div-->
		<span class="text-3xl">User List</span>
		<div v-if="user.adminData !== null" class="pt-8">
			<table class="table-auto border-seperate w-full">
				<tr class="table-row border winwin-bg">
					<th>Name</th>
					<th>Employee ID</th>
					<th>Email Address</th>
					<th>Email Verified</th>
					<th>Is Admin</th>
				</tr>
				<template v-for="data in user.adminData">
					<tr
						v-if="data.Profile !== null"
						:key="data.index"
						class="border-white border"
					>
						<td class="underline">
							<router-link
								:to="{ name: 'User_ID', params: { User_Id: data.UserId } }"
							>
								<span>{{ data.Profile.FirstName }} {{ data.Profile.LastName }}</span>
								<!-- <span v-else>Profile Not initialized</span> -->
							</router-link>
						</td>
						<td>
							<span>{{
								data.Profile.EmployeeId
							}}</span>
							<!-- <span v-else>Profile Not initialized</span> -->
						</td>
						<td>
							<span
								v-if="data.Profile.EmailAddress !== null"
							>
								{{ data.Profile.EmailAddress }}
							</span>
							<span v-else>Profile Not initialized</span>
						</td>
						<td>{{ data.IsVerified }}</td>
						<td>{{ data.IsStrideAdmin }}</td>
					</tr>
				</template>
			</table>
		</div>
		<div v-else>User List is Empty...</div>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";

	export default {
		name: "AdminUserList",
		props: ["skip"],
		computed: {
			...mapGetters({
				user: "user",
			}),
		},
	};
</script>

<style lang="scss" scoped>
	.winwin-bg {
		background-color: #e4b763;
		border-color: #e4b763;
		margin: 5px 0;
	}

	th {
		padding: 10px 0;
	}

	td {
		padding: 5px 0;
	}

	tr:nth-child(even) {
		background-color: rgb(107, 114, 128);
	}
</style>
